/* Black Friday CRO: add-on bundling + sticky add to cart */
(function () {
  if (window.__bfCroLoaded) return;
  window.__bfCroLoaded = true;

  function mainForm() {
    return document.getElementById('addToCartForm') ||
      document.querySelector('form[action*="/cart/add"]');
  }
  function mainButton() {
    var f = mainForm();
    return f ? (f.querySelector('#addToCart') || f.querySelector('[name="add"], [type="submit"]')) : null;
  }
  function checkedAddons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-bf-addon]:checked'));
  }

  /* Add-ons: when any are ticked, add oven + add-ons together, then go to cart */
  var busy = false;
  function addWithAddons(e) {
    var f = mainForm();
    if (!f) return;
    var target = e.target;
    var mb = mainButton();
    var isSubmit = e.type === 'submit' ? target === f : !!(mb && target && mb.contains(target));
    if (!isSubmit) return;
    var extras = checkedAddons();
    if (!extras.length) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var idInput = f.querySelector('[name="id"]');
    var qtyInput = f.querySelector('[name="quantity"]');
    var items = [{ id: Number(idInput && idInput.value), quantity: Math.max(1, Number(qtyInput && qtyInput.value) || 1) }];
    extras.forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });

    var btn = mainButton();
    if (btn) btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = root + 'cart';
    }).catch(function () {
      busy = false;
      if (btn) btn.removeAttribute('aria-busy');
      f.submit(); /* fall back to adding the oven alone */
    });
  }
  window.addEventListener('click', addWithAddons, true);
  window.addEventListener('submit', addWithAddons, true);

  /* Sticky bar */
  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]');
    var btn = mainButton();
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    var stickyBtn = bar.querySelector('[data-bf-sticky-btn]');
    var shown = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0; /* button scrolled above the viewport */
      shown = !e.isIntersecting && below;
      bar.classList.toggle('is-visible', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      stickyBtn.tabIndex = shown ? 0 : -1;
    });
    io.observe(btn);
    stickyBtn.addEventListener('click', function () {
      var b = mainButton();
      if (!b) return;
      b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { b.click(); }, 350);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
